<template>
  <mrc_ess_skeleton_loader
    :loading="$store.state.uuid ? skeletonloading : false"
  >
    <v-card>
      <v-card-text>
        <v-col cols="12" class="d-flex">
          <mrc_ess_switch
            :true-value="1"
            :false-value="0"
            v-if="$store.state.uuid"
            :readonly="disabled"
            v-model="list.status"
            :true-text="$t('label_To_enable_the')"
            :false-text="$t('label_disable')"
          ></mrc_ess_switch>
        </v-col>
        <v-row>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_The_name_of_the_task') + '*'"
              :isNational="judegNational('job_name')"
              :readonly="disabled"
              :error-messages="
                $errors('list', 'job_name', requiredRule.concat(nocharacter))
              "
              v-model="list.job_name"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_prompt
              :label="$t('label_grouping') + '*'"
              :disabled="disabled"
              :rules="false"
              :chips="false"
              :errMsg="$errors('list', 'job_group', requiredRule)"
              v-model="list.job_group"
              obj="group_name"
            >
            </mrc_ess_prompt>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText
              :label="$t('label_Call_target_string') + '*'"
              :isNational="judegNational('invoke_target')"
              :error-messages="$errors('list', 'invoke_target', requiredRule)"
              :readonly="disabled"
              v-model="list.invoke_target"
            >
            </mrc_ess_multiText>
            <div class="d-flex flex-column-reverse">
              <span>
                <mrc_ess_svgIcon
                  class="mr-1"
                  icon-class="info-24px"
                  style="font-size: 24px"
                ></mrc_ess_svgIcon>
                <span>{{
                  $t("label_Note:_bean_naming_cannot_contain_dots") + '"."'
                }}</span>
                <!-- <span> 注：bean命名不能带点'.'</span> -->
              </span>
              <span>
                <mrc_ess_svgIcon
                  class="mr-1"
                  icon-class="info-24px"
                  style="font-size: 24px"
                ></mrc_ess_svgIcon>
                <span>{{ $t("label_Time_zone_for_timing_tasks:_UTC") }}</span>
                <!-- <span>定时任务执行时区：UTC</span> -->
              </span>
              <span class="d-flex">
                <span class="mr-1">
                  <mrc_ess_svgIcon
                    icon-class="info-24px"
                    style="font-size: 24px"
                  ></mrc_ess_svgIcon>
                </span>
                <span>
                  {{ $t("label_Bean_invocation_example") }}
                  :RyTask.ryParams('ry')
                </span>
              </span>
              <span>
                <span>
                  <mrc_ess_svgIcon
                    icon-class="info-24px"
                    style="font-size: 24px"
                  ></mrc_ess_svgIcon>
                </span>
                <span>
                  {{
                    $t("label_Class_Class_invocation_example")
                  }}:com.ruoyi.quarts.task.RyTask.ryParams('ry')
                </span>
              </span>
              <span>
                <span>
                  <mrc_ess_svgIcon
                    icon-class="info-24px"
                    style="font-size: 24px"
                  ></mrc_ess_svgIcon>
                </span>
                <span>
                  {{ $t("label_Parameters_that") }}:{{
                    $t("label_String_support")
                  }}、{{ $t("label_Boolean_type") }}、{{
                    $t("label_Long_integer_type")
                  }}、{{ $t("label_Swim_point_type") }}、{{
                    $t("label_The_integer")
                  }}
                </span>
              </span>
              <span> </span>
            </div>
          </v-col>
          <v-col cols="12">
            <!-- 0/30 * * * * ? * -->
            <!-- <v-text-field v-model="list.cron_expression"
                              :readonly="disabled"
                              :error-messages="$errors('list','cron_expression',requiredRule)"
                              label="Cron 表达式*">
                </v-text-field> -->
            <mrc_ess_multiText
              v-model="list.cron_expression"
              :readonly="disabled"
              :isNational="judegNational('cron_expression')"
              :error-messages="$errors('list', 'cron_expression', requiredRule)"
              :label="$t('label_Cron_expression') + '*'"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <v-radio-group
              v-model="list.misfire_policy"
              :disabled="disabled"
              row
            >
              <v-radio
                :label="$t('label_Executed_immediately')"
                v-if="hasBtn('scheduled-job-execute-now')"
                value="1"
              ></v-radio>
              <v-radio
                :label="$t('label_Perform_a')"
                v-if="hasBtn('scheduled-job-execute-once')"
                value="2"
              ></v-radio>
              <v-radio
                :label="$t('label_Give_up_to_perform')"
                v-if="hasBtn('termination-execution')"
                value="3"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6">
            <v-checkbox
              v-model="list.concurrent"
              :disabled="disabled"
              :true-value="1"
              :false-value="0"
              :label="
                list.concurrent == 1
                  ? $t('label_Allow_concurrent_execution')
                  : $t('label_disabledConcurrentExecution')
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="6">
            <v-checkbox
              v-model="list.is_send_mail"
              :disabled="disabled"
              :true-value="1"
              :false-value="0"
              :label="
                list.is_send_mail == 1
                  ? $t('label_timeTask_m_sendMail')
                  : $t('label_timeTask_m_notSendMail')
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText
              :label="$t('label_note')"
              noRequired
              :error-messages="$errors('list', 'remark', nocharacter)"
              :isNational="judegNational('remark')"
              :readonly="disabled"
              v-model="list.remark"
            >
            </mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn
        @cancel="cancel"
        v-if="!disabled"
        @success="success"
      ></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>
<style scoped></style>
<script>
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
import {
  verifyCron,
  deatailTimedTask,
  addTimedTask,
  updateTimedTask,
  deleteTimedTask,
  updateTimedTaskStatus,
  getLogList,
  executeTimedTask,
} from "@/service/api/pushTask.js";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      skeletonloading: true,
      items: [],
      list: {
        status: 1,
        misfire_policy: "1",
        concurrent: 1,
        is_send_mail: 1,
      },
    };
  },
  validations: {
    list: {
      job_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      job_group: {
        required,
      },
      invoke_target: {
        required,
      },
      cron_expression: {
        required,
      },
      remark: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
    },
  },
  created() {},
  async mounted() {
    //mrbase_sys_timed_task    定时任务表             mrbase_sys_timed_task_log 定时任务日志表
    this.national("mrbase_sys_timed_task");
    if (this.$store.state.uuid) {
      await this.getDetail();
    } else {
    }
  },
  methods: {
    async getDetail() {
      this.skeletonloading = true;
      const res = await deatailTimedTask({ uuid: this.$store.state.uuid });
      if (res.code == 200) {
        this.list = res.data;
      } else {
      }
      this.skeletonloading = false;
    },
    async verifyCron() {
      const res = await verifyCron({
        cron_expression: this.list.cron_expression,
      });
      if (res.code == 200) {
        return true;
      }
      // this.$Message({ text: this.$t('message_Expression_error') })
      return false;
    },
    cancel() {
      if (this.$store.state.uuid) {
        this.getDetail();
        this.$emit("changeReadonly");
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            this.$router.push({
              name: "pushTask",
            });
          })
          .catch((err) => {});
      }
    },
    async success() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      const res = await this.verifyCron();
      if (!res) return;
      if (this.$store.state.uuid) {
        updateTimedTask(this.list).then((res) => {
          if (res.code == 200) {
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            this.getDetail();
            this.$emit("changeReadonly");
          }
        });
      } else {
        addTimedTask(this.list).then((res) => {
          if (res.code == 200) {
            this.$Message({ text: this.$t("message_added_successfully") });
            this.$router.push({ name: "pushTask" });
          }
        });
      }
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped></style>
